import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

type Surface = 'board' | 'rail' | 'canvas';
type Elevation = 'flat' | 'card' | 'subtle' | 'float';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  surface?: Surface;
  elevation?: Elevation;
  as?: 'div' | 'section' | 'article';
  bordered?: boolean;
}

const surfaceClasses: Record<Surface, string> = {
  board: 'bg-board',
  rail: 'bg-rail',
  canvas: 'bg-canvas',
};

const elevationClasses: Record<Elevation, string> = {
  flat: '',
  card: 'shadow-card',
  subtle: 'shadow-subtle',
  float: 'shadow-float',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  {
    surface = 'board',
    elevation = 'card',
    bordered = true,
    as: Tag = 'div',
    className,
    children,
    ...props
  },
  ref,
) {
  return (
    <Tag
      ref={ref as never}
      className={cn(
        'rounded-xl',
        surfaceClasses[surface],
        elevationClasses[elevation],
        bordered && 'border border-line',
        className,
      )}
      {...props}
    >
      {children}
    </Tag>
  );
});
